
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseQuotationItemsGrid extends _Ext.GridBase<QuotationItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.QuotationItems'; }
        protected getDialogType() { return QuotationItemsDialog; }
        protected getIdProperty() { return QuotationItemsRow.idProperty; }
        protected getLocalTextPrefix() { return QuotationItemsRow.localTextPrefix; }
        protected getService() { return PurchaseQuotationSelectItemsService.baseUrl; }
         
        private autoSize;
        public rowSelection: Serenity.GridRowSelectionMixin;
       
        
        constructor(container: JQuery, options) {
            super(container, options);

            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;
            (this.view.params as TransactionRequest).InStock = options.GridFilters.InStock;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): QuotationItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }




        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}